import axios from 'axios';
import Utils from '../Utils';
import { getLangBaseOnURLPath } from './i18nConfiguration'
import { get, isEmpty } from 'lodash';
import { LOCAL_STORAGE_KEY } from '../Foundation';
import StorageHelper from '../StorageHelper';
import Constants from '../Constants';

export const defautRequestConfig = {
  baseURL: '/'
}

const getCustomHeader = () => {
  if (!StorageHelper.isHeaderBasedEnable()) return {};
  const xAppDataHeader = StorageHelper.getXAppDataHeader();
  const authenticationHeader = Utils.convertStringToJSON(StorageHelper.getBrowsersStorage(LOCAL_STORAGE_KEY.TOKEN));

  return isEmpty(xAppDataHeader) ?
    authenticationHeader :
    {
      ...authenticationHeader,
      ...{ [LOCAL_STORAGE_KEY.APP_DATA]:  xAppDataHeader }
    };
}

const defaultRestApi = axios.create(defautRequestConfig);
defaultRestApi.interceptors.request.use(function (config) {
    config.params = {
      locale: Utils.toLocaleCode(getLangBaseOnURLPath()),
      '_': new Date().getTime(),
      withCredentials: true
      };
      const customHeader = getCustomHeader()
      if (!isEmpty(customHeader)) {
        config.headers = {
          ...config.headers,
          ...customHeader
        }
      }
    const vhuCode = StorageHelper.getVHCODE()
    if(!!vhuCode){
      config.headers[LOCAL_STORAGE_KEY.V_HUCODE] = vhuCode
    }
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

defaultRestApi.interceptors.response.use(response => {
  const xAppDataHeader = get(response, `headers[${LOCAL_STORAGE_KEY.APP_DATA}]`, '');

  if (!isEmpty(xAppDataHeader)) {
    StorageHelper.saveXAppData(xAppDataHeader);
  }

  return response;
});
export default defaultRestApi;




// WEBPACK FOOTER //
// ./src/app/common/config/RestApiInstance.js